import { z } from 'zod'
import { containsNewLine } from '@App/helpers/work-entities-fields-validators'
import { ISWCValidator } from '@App/helpers/validate'
import {
    durationMessage,
    newlineMessage,
    numericMessage,
    requiredMessage,
    stringMessage,
    stringSizeMaxMessage,
    stringSizeMinMessage,
} from '@Entities/schemas/work/error-messages'
import { DURATION_REGEX } from '@Const/regexp'

const workDetailsSchema = z.object({
    title: z
        .string({
            error: (issue) => (issue.received === 'undefined' ? requiredMessage('Title') : stringMessage('Title')),
        })
        .min(1, stringSizeMinMessage('Title', 1))
        .max(200, stringSizeMaxMessage('Title', 200))
        .refine((val) => !containsNewLine(val), newlineMessage('Title')),
    duration: z
        .string({
            error: (issue) =>
                issue.received === 'undefined' ? requiredMessage('Duration') : stringMessage('Duration'),
        })
        .regex(DURATION_REGEX, durationMessage())
        .or(z.literal(''))
        .nullable(),
    languageCode: z
        .number({
            error: (issue) =>
                issue.received === 'undefined' ? requiredMessage('Language code') : numericMessage('Language code'),
        })
        .nullable(),
    copyrightOfficeNumber: z
        .string({
            error: (issue) =>
                issue.received === 'undefined'
                    ? requiredMessage('Copyright office number')
                    : stringMessage('Copyright office number'),
        })
        .max(12, stringSizeMaxMessage('Copyright office number', 12))
        .nullable(),
    copyrightOfficeDate: z
        .string({
            error: (issue) =>
                issue.received === 'undefined'
                    ? requiredMessage('Copyright office date')
                    : stringMessage('Copyright office date'),
        })
        .nullable(),
    firstUseRefusalIndicator: z.boolean().nullable(),
    rightsholderProprietaryId: z
        .string({
            error: (issue) =>
                issue.received === 'undefined'
                    ? requiredMessage('Member Work Identifier')
                    : stringMessage('Member Work Identifier'),
        })
        .max(14, stringSizeMaxMessage('Member Work Identifier', 14))
        .nullable(),
    iswc: z
        .string({
            error: (issue) => (issue.received === 'undefined' ? requiredMessage('ISWC') : stringMessage('ISWC')),
        })
        .refine((val) => ISWCValidator(val), 'Invalid ISWC format')
        .nullable(),
    holdTypeId: z
        .number({
            error: (issue) =>
                issue.received === 'undefined' ? requiredMessage('ISHold typeWC') : numericMessage('Hold type'),
        })
        .optional()
        .nullable(),
})

export type WorkDetailsType = z.infer<typeof workDetailsSchema>

export default workDetailsSchema
